// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"Xz4hSAIZkCjBJL0nNI2Jr"};